import Link from 'next/link';
import React, { AnchorHTMLAttributes } from 'react';
import { Slot } from '@radix-ui/react-slot';
import styles from './styles.module.css';
import { cn } from '@/lib/utils';

interface IAnimatedLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  asChild?: boolean;
}

export const AnimatedLink: React.FC<IAnimatedLinkProps> = ({
  href,
  children,
  className = '',
  target,
  asChild = false,
}) => {
  const Comp = asChild ? Slot : Link;

  return (
    <Comp
      href={href || '/'}
      className={cn(
        'uppercase tracking-[.20em] group font-semibold py-5  text-sm px-10 mt-8 hover:text-white bg-primary text-white desktop:bg-transparent desktop:text-gray-900',
        styles['button-animation'] ? styles['button-animation'] : '',
        className,
      )}
      target={target}>
      {children}
    </Comp>
  );
};
